/*
  FlorEasy - Pont "devis -> Meta Lead"
  ------------------------------------
  Publie un evenement client Shopify (floreasy_devis_submitted) au moment ou
  un devis est reellement enregistre, une seule fois par devis.
  Le pixel personnalise "Meta - Lead devis" ecoute cet evenement et envoie le
  Lead a Meta avec sa valeur reelle.

  Ne modifie aucun comportement existant : enveloppe simplement les fonctions
  de FlorEasyDevisStore. Tout est protege par try/catch, le questionnaire
  continue de fonctionner meme si ce script echoue.
*/
(function (w) {
  'use strict';

  var KEY = 'floreasy_meta_lead_reported';
  var MAX = 300;

  function readReported() {
    try {
      var raw = w.localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function claim(devisId) {
    var id = String(devisId || '');
    if (!id) return false;
    try {
      var list = readReported();
      if (list.indexOf(id) !== -1) return false;
      list.unshift(id);
      w.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
      return true;
    } catch (e) {
      return true;
    }
  }

  function newEventId() {
    try {
      if (w.crypto && typeof w.crypto.randomUUID === 'function') {
        return w.crypto.randomUUID();
      }
    } catch (e) {}
    return 'lead_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
  }

  function toNumber(value) {
    if (typeof value === 'number') return isFinite(value) ? value : 0;
    var src = String(value == null ? '' : value);
    var kept = '';
    for (var i = 0; i < src.length; i++) {
      var c = src.charAt(i);
      if (c >= '0' && c <= '9') kept += c;
      else if (c === ',' || c === '.') kept += c;
    }
    if (!kept) return 0;
    var comma = kept.lastIndexOf(',');
    var dot = kept.lastIndexOf('.');
    if (comma > -1 && dot > -1) {
      kept = comma > dot
        ? kept.split('.').join('').split(',').join('.')
        : kept.split(',').join('');
    } else if (comma > -1) {
      kept = kept.split(',').join('.');
    }
    var n = parseFloat(kept);
    return isFinite(n) ? Math.round(n * 100) / 100 : 0;
  }

  function publish(devis) {
    try {
      if (!devis || !devis.id) return;
      if (!claim(devis.id)) return;

      var snap = devis.snapshot || {};
      var payload = {
        devis_id: String(devis.id),
        event_id: newEventId(),
        value: toNumber(devis.budgetTotal),
        currency: 'EUR',
        univers: devis.univers || '',
        participants: devis.participants || 1,
        wedding_date: snap.weddingDate || '',
        email: snap.email || '',
        phone: snap.phone || '',
        first_name: snap.firstName || '',
        last_name: snap.lastName || '',
        postal_code: snap.postalCode || ''
      };

      if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') {
        w.Shopify.analytics.publish('floreasy_devis_submitted', payload);
      }
    } catch (e) {}
  }

  function extract(result) {
    if (!result) return null;
    if (result.devis) return result.devis;
    if (result.id) return result;
    return null;
  }

  function wrap(store, name) {
    var original = store[name];
    if (typeof original !== 'function') return;
    store[name] = function () {
      var out = original.apply(this, arguments);
      try {
        if (out && typeof out.then === 'function') {
          return out.then(function (res) {
            publish(extract(res));
            return res;
          });
        }
        publish(extract(out));
      } catch (e) {}
      return out;
    };
  }

  function install() {
    var store = w.FlorEasyDevisStore;
    if (!store) return false;
    if (store.__metaLeadBridge) return true;
    store.__metaLeadBridge = true;
    wrap(store, 'saveSynced');
    wrap(store, 'save');
    wrap(store, 'saveByEmail');
    return true;
  }

  if (!install()) {
    var tries = 0;
    var timer = w.setInterval(function () {
      tries += 1;
      if (install() || tries > 150) w.clearInterval(timer);
    }, 200);
  }
})(window);
